import React from 'react'
import styled, { StyledProps } from 'styled-components'
import { useTranslation } from 'react-i18next'
import { IconArrowBack } from '../../iconography/Icons/Icons'

const BackBtnStyled = styled.button`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  transition: 0.3s color;
  display: inline-flex;
  align-items: center;
  background-color: transparent;
  border: none;
  color: ${({ theme }: StyledProps<{}>) => theme.color.secondary200};
  cursor: pointer;
  padding: 0;

  &:hover {
    color: ${({ theme }: StyledProps<{}>) => theme.color.primary600};
  }

  &:focus {
    outline: none;
  }

  margin-bottom: 14px;
`
const BackIconStyled = styled(IconArrowBack)`
  transition: 0.3s fill;
  fill: currentColor;
  margin-right: 12px;
`

export const BackBtn: React.FC<{ onClick: () => void; className?: string; text?: string }> = ({
  onClick,
  className,
  text,
}) => {
  const { t } = useTranslation('ui')
  return (
    <BackBtnStyled onClick={onClick} className={className}>
      <BackIconStyled />
      {text || t('common.back')}
    </BackBtnStyled>
  )
}
